import * as React from 'react';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import SelectField from '../../common/form-controls/SelectField';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';
import { InfoIcon, TextPassage } from 'react-unity';

interface OnPremPORTypeInputProps {
	scope: FieldHandler<string>;
}

interface PORTypeInputState { }

export class OnPremPORTypeInput extends React.Component<OnPremPORTypeInputProps, PORTypeInputState> {

	scopeOptions = () => {
		return [
			{ value: PortOpeningRequestsDirection.DomainToConnection.name, text: PortOpeningRequestsDirection.DomainToConnection.displayName },
			{ value: PortOpeningRequestsDirection.DomainToInternet.name, text: PortOpeningRequestsDirection.DomainToInternet.displayName },
			{ value: PortOpeningRequestsDirection.DomainProxyToInternet.name, text: PortOpeningRequestsDirection.DomainProxyToInternet.displayName }
		];
	};
	
	render() {
		return (
			<TextPassage>
				<>
					<div id="text-passage">
						Scope <InfoIcon className="info-icon em-c-field__label" />
					</div>
					{
						{
						'ChinaDomainToConnection': <div> ChinaDomain -{'>'} Connection : is involve L3/L4 firewall ACL Update</div>,
						'ChinaDomainToInternet': <div>ChinaDomain -{'>'} Internet : is On-Prem towards Internet</div>,
						'DomainProxyToInternet': <div>China iBoss/Proxy -{'>'} Internet : is for Proxy towards internet connection</div>
						}[this.props.scope.value]
					}
				</>

				<SelectField
					label=""
					className="full-width"
					options={this.scopeOptions()}
					{...this.props.scope}
				/>
			</TextPassage>
		);
	}
}
